import { render, staticRenderFns } from "./ModalUploadImageSpecimen.vue?vue&type=template&id=5cf75c40"
import script from "./ModalUploadImageSpecimen.vue?vue&type=script&lang=js"
export * from "./ModalUploadImageSpecimen.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadImageSpecimen.vue?vue&type=style&index=0&id=5cf75c40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports